module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_1.821b730b.png";